<template>
  <v-card>
    <v-card-title>Параметр "{{ itemMedParam.med_param_name }}"</v-card-title>

    <v-card-text v-if="items.length">
      <IkpMedParamValuesChart :name="itemMedParam.med_param_name" :items="items" />
    </v-card-text>

    <v-card-text>
      <v-data-table
        item-key="id"
        loading-text="Загрузка... Пожалуйста подождите"
        hide-default-footer
        disable-pagination
        :headers="headers"
        :items="items"
        :loading="loading"
        :options.sync="options"
      ></v-data-table>
    </v-card-text>
    <v-card-actions></v-card-actions>
  </v-card>
</template>

<script>
import IkpMedParamValuesChart from "@/views/pages/ikp/components/IkpMedParamValuesChart.vue";

export default {
  name: "ModalIkpMedParamDetail",
  components: { IkpMedParamValuesChart },
  props: {
    itemMedParam: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        {
          text: "Дата",
          align: "start",
          sortable: true,
          value: "date",
        },
        {
          text: "Значение",
          align: "start",
          sortable: false,
          value: "value",
        },
      ],
      loading: false,
      items: [],
      options: {},
    };
  },

  computed: {
    customerId() {
      return this.$store.state.customer.id;
    },
  },

  async created() {
    await this.load();
  },

  methods: {
    async load() {
      this.loading = true;
      const { data } = await this.$http.get(
        `v1/customers/${this.customerId}/params/${this.$props.itemMedParam.med_param_id}/measurements`,
        {
          params: { date: this.$props.itemMedParam.date_without_time },
        },
      );

      this.items = (data.data ?? []).map(item => ({ ...item, name: this.$props.itemMedParam.med_param_name }));
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
